define('KeepSessionActive.EntrySS2Model', [
  'SCModel',
  'Utils'
], function (SCModelComponent, Utils) {
  'use strict';

  var SCModel = SCModelComponent.SCModel;
  function KeepSessionActiveEntrySS2Model() {
    SCModel.call(this);

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        getExtensionAssetsPath('Modules/KeepSessionActive/SuiteScript2/KeepSessionActive.Service.ss'),
        true
      );
    };
  }

  KeepSessionActiveEntrySS2Model.prototype = Object.create(SCModel.prototype);
  KeepSessionActiveEntrySS2Model.prototype.constructor = KeepSessionActiveEntrySS2Model;
  return KeepSessionActiveEntrySS2Model;
}
);
